import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import columns from "../../../columns/ibApproved/accepted";
import TableWithSkeleton from "../../../components/global/table/TableWithSkeleton";
import Pagination from "../../../components/global/pagination/Pagination.jsx";
import ModalComponent from "../../../components/global/modal/ModalComponent.jsx";
import {
  GetAllibApi,
  GetAllIBByIdApi,
  UpdateIbWithdrawSettingApi,
} from "../../../api/request/ibapproved.js";
import moment from "moment";
import Eye from "../../../assets/Eye.jsx";
import { Form, Select, Spin, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import UserAvatar from "../../../components/global/avtar/UserAvatar.jsx";
import Setting from "../../../assets/Setting";
import { GetTraderAccountsByIdApi } from "../../../api/request/client.js";
import LoadableButton from "../../../components/buttons/LoadableButton.jsx";
import useModulePermissions from "../../../hooks/useModulePermissions.jsx";
import { ApartmentOutlined } from "@ant-design/icons";

export default function IbAccepted({ dates }) {
  const ibManagerPermissions = useModulePermissions("ib_manager");
  const canAcceptReject = !!ibManagerPermissions.accept_reject;

  const navigate = useNavigate();
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingIBDetails, setIsLoadingIBDetails] = useState(false);
  const [isApprove, setIsPending] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);
  const [data, setData] = useState([]);
  const [selectedIBId, setSelectedIBId] = useState("");
  const [iBDetails, setIBDetails] = useState({});
  const [sorter, setSorter] = useState({ SortBy: "actionDate", SortOrder: "" });

  const [settingForm] = Form.useForm();
  const [accounts, setAccounts] = useState([]);
  const [isWithdrawSettingOpen, setIsWithdrawSettingOpen] = useState(false);
  const [isSettingLoading, setIsSettingLoading] = useState(false);

  const getAllIB = async () => {
    try {
      let params = {
        PageNumber: page,
        PageSize: pageSize,
        SearchText: dates,
        FilterText: "Approved",
        ...sorter,
      };
      setIsLoading(true);
      const { data } = await GetAllibApi(
        new URLSearchParams(params).toString(),
      );
      if (data?.success) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              name: (
                <UserAvatar
                  data={{
                    name: `${item?.firstName} ${item?.lastName}`,
                    email: item?.email,
                  }}
                />
              ),
              requestDate: item?.requestDate
                ? moment(item?.requestDate).format("DD-MM-YYYY, hh:mm A")
                : null,
              actionDate: item?.actionDate
                ? moment(item?.actionDate).format("DD-MM-YYYY, hh:mm A")
                : null,
              action: (
                <div className="flex items-center gap-3">
                  <button
                    type="button"
                    onClick={() =>
                      navigate(`/ib_details/approved/${item?.userId}`)
                    }
                  >
                    <Eye />
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setSelectedIBId(item?.userId);
                      setIsWithdrawSettingOpen(true);
                    }}
                  >
                    <Setting />
                  </button>
                  <Tooltip title="IB Tree">
                    <button
                      type="button"
                      className="text-lg text-[#539198]"
                      onClick={() =>
                        navigate(`/ib_manager/ib_tree/${item?.userId}`)
                      }
                    >
                      <ApartmentOutlined />
                    </button>
                  </Tooltip>
                
                </div>
              ),
            };
          }),
        );
        setTotalRecord(data?.totalRecords);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getAccounts = async () => {
    try {
      const { data } = await GetTraderAccountsByIdApi(selectedIBId, true);
      if (data?.success) {
        const accountOptions = data?.data?.map((item) => {
          return {
            label: item?.login,
            value: item?.login,
          };
        });
        setAccounts(accountOptions);
      }
    } catch (error) {}
  };

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter?.order) {
      setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
    } else {
      setSorter({ SortBy: "actionDate", SortOrder: "" });
    }
  };

  useEffect(() => {
    getAllIB();
  }, [page, pageSize, sorter, dates]);

  useEffect(() => {
    setPage(1);
  }, [dates]);

  const getIBById = async () => {
    try {
      setIsLoadingIBDetails(true);
      const { data } = await GetAllIBByIdApi(selectedIBId);
      setIBDetails(data?.data);
      setIsLoadingIBDetails(false);
    } catch (error) {
      setIsLoadingIBDetails(false);
    }
  };

  useEffect(() => {
    if (selectedIBId) {
      getIBById();
      getAccounts();
      const selectedIb = data?.find((item) => item?.userId === selectedIBId);
      settingForm.setFieldsValue({
        account: selectedIb?.commissionAccount || null,
      });
    }
  }, [selectedIBId]);

  const handleSettingsSubmit = async (values) => {
    try {
      setIsSettingLoading(true);
      const { data } = await UpdateIbWithdrawSettingApi({
        account: values?.account,
        ibUserId: selectedIBId,
      });
      if (data?.success) {
        toast.success(data?.message);
        setIsWithdrawSettingOpen(false);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setIsSettingLoading(false);
    }
  };

  return (
    <>
      {/* Approved table */}
      <div className="my-6">
        <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
          <TableWithSkeleton
            columns={columns}
            data={data}
            loading={isLoading}
            onChange={handleTableChange}
            // hiddenColumns={!canAcceptReject ? ["Actions"] : []}
            page={page}
            pageSize={pageSize}
            index={true}
          />
        </div>
        <Pagination
          total={totalRecord}
          pageSize={pageSize}
          setPageSize={setPageSize}
          page={page}
          setPage={setPage}
        />
      </div>

      {/* approved modal */}
      <ModalComponent
        isOpen={isApprove}
        setIsOpen={setIsPending}
        title="IB Details"
        width={1300}
      >
        {isLoadingIBDetails ? (
          <div className="flex justify-center flex-col my-[5%]">
            <Spin size="large" />
            <p className="primary text-center mt-2">Loading...</p>
          </div>
        ) : (
          <div className="p-5">
            <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10 ">
              <div>
                <p className="text-base font-normal ">First Name</p>
                <p className="text-xl primary font-semibold  mt-2">
                  {iBDetails?.firstName}
                </p>
              </div>
              <div>
                <p className="text-base font-normal ">Last Name</p>
                <p className="text-xl primary font-semibold  mt-2">
                  {iBDetails?.lastName}
                </p>
              </div>
              <div>
                <p className="text-base font-normal ">Mobile No.</p>
                <p className="text-xl primary font-semibold  mt-2">
                  {iBDetails?.phoneNo}
                </p>
              </div>
              <div>
                <p className="text-base font-normal ">Email</p>
                <p className="text-xl primary font-semibold  mt-2">
                  {iBDetails?.email}
                </p>
              </div>
              <div>
                <p className="text-base font-normal ">Approve Time</p>
                <p className="text-xl primary font-semibold  mt-2">
                  {iBDetails?.actionDate
                    ? moment(iBDetails?.actionDate).format(
                        "DD-MM-YYYY, hh:mm A",
                      )
                    : "--"}
                </p>
              </div>
              <div>
                <p className="text-base font-normal ">Request Time</p>
                <p className="text-xl primary font-semibold  mt-2">
                  {iBDetails?.createdDate
                    ? moment(iBDetails?.createdDate).format(
                        "DD-MM-YYYY, hh:mm A",
                      )
                    : "--"}
                </p>
              </div>
              <div>
                <p className="text-base font-normal ">IB User</p>
                <p className="text-xl primary font-semibold  mt-2">
                  {iBDetails?.isIBUser === true ? "yes" : "No"}
                </p>
              </div>
            </div>
          </div>
        )}
      </ModalComponent>

      <ModalComponent
        isOpen={isWithdrawSettingOpen}
        setIsOpen={setIsWithdrawSettingOpen}
        title="Withdraw Account Settings"
      >
        <div>
          <Form
            form={settingForm}
            layout="vertical"
            onFinish={handleSettingsSubmit}
          >
            <Form.Item
              name="account"
              label="Withdraw Account"
              rules={[{ required: true, message: "Please select account!" }]}
            >
              <Select
                size="large"
                placeholder="Select account"
                options={accounts}
              />
            </Form.Item>

            <div className="flex justify-end items-center gap-5 mt-8">
              <LoadableButton
                type="submit"
                className="bg-primary text-sm text-white font-medium uppercase px-10 py-2 rounded-lg hover:bg-primary duration-500"
                lable="Submit"
                isLoading={isSettingLoading}
                loadingLable="Submitting..."
              />
            </div>
          </Form>
        </div>
      </ModalComponent>
    </>
  );
}
